import { render, staticRenderFns } from "./myBid.vue?vue&type=template&id=04b6360c"
import script from "./myBid.vue?vue&type=script&lang=js"
export * from "./myBid.vue?vue&type=script&lang=js"
import style0 from "./myBid.vue?vue&type=style&index=0&id=04b6360c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports